import { FC, PropsWithChildren } from 'react'
import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material'

export const Skeleton: FC<PropsWithChildren<{ isLoading: boolean } & SkeletonProps>> = ({ isLoading, children, ...rest }) => {
  return isLoading ? (
    <MuiSkeleton component={'div'} {...rest}>
      {children}
    </MuiSkeleton>
  ) : (
    children
  )
}
